import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtBtn from "./CustomTool/CtBtn";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { type } from "@testing-library/user-event/dist/type";
import Checkbox from "@mui/material/Checkbox";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import {
  get_YMD_from_SYS,
  isValidItem,
  applyTrimOnObjectValues,
  getRoundOff,
  getString_or_Blank4Null,
  validatedate_min_max,
  get_30DaysBack_FromCurrentDate,
  getlocalstoragedate,
  setlocalstoragedate,
} from "../SystemUtility/SystemUtility";
import FormControlLabel from "@mui/material/FormControlLabel";
import { apiURL, fetchCustomerMaster, fetchSales } from "./API";
import ResetDate from "../images/resetdate.png";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtCmb from "./CustomTool/CtCmb";

class SalesReport extends Component {
  state = {
    formData: {
      dtpFromDate: "",
      dtpToDate: "",
      //   cmbType: "Date Wise Summary",
      cmbCustomer: "",
      chekNewpage: false,
    },
    types: [
      { type: "Date Wise Summary" },
      { type: "Date Wise Detail" },
      { type: "Date Wise Detail With Item" },
      { type: "Customer wise Summary" },
      { type: "Customer wise Detail" },
      { type: "Customer wise Detail With Item" },
    ],
    customers: [],
  };

  //#region Component
  componentDidMount() {
    document.title = "RA : Sales Report";
    this.props.setActiveMenu("SaleReport");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  //#endregion Component

  //#region Handles
  handleOnChange = (e) => {
    // this.setState(
    //   {
    //     formData: {
    //       ...this.state.formData,
    //       [e.target.name]: e.target.value,
    //     },
    //   },
    //   () => {
    //     if (e.target.name === "cmbType") {
    //       if (
    //         this.state.formData.cmbType === "Date Wise Summary" ||
    //         this.state.formData.cmbType === "Date Wise Detail"
    //       ) {
    //         //#To hide the checkbox and set it's value = ""
    //         this.setState({
    //           formData: {
    //             ...this.state.formData,
    //             chekNewpage: false,
    //           },
    //         });
    //       }
    //     } else if (
    //       e.target.name === "dtpFromDate" ||
    //       e.target.name === "dtpToDate"
    //     ) {
    //       this.setfrom_todate();
    //     }
    //   }
    // );
  };

  handleOnCheckChange = (e) => {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.checked,
      },
    });
  };
  //#endregion Handles

  //   //#region Function
  //   getCmbType4BE(ReportType) {
  //     if (ReportType === "Date Wise Summary") {
  //       return "SalesDateWiseSummary";
  //     } else if (ReportType === "Date Wise Detail") {
  //       return "SalesDateWiseDetail";
  //     } else if (ReportType === "Date Wise Detail With Item") {
  //       return "SalesDateWiseItemDetail";
  //     } else if (ReportType === "Customer wise Summary") {
  //       return "SalesCustomerWiseSummary";
  //     } else if (ReportType === "Customer wise Detail") {
  //       return "SalesCustomerWiseDetail";
  //     } else if (ReportType === "Customer wise Detail With Item") {
  //       return "SalesCustomerWiseItemDetail";
  //     }
  //   }

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chekNewpage"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  //   validateFromToDate = () => {
  //     let result = false;
  //     if (this.state.formData.cmbType.length <= 0) {
  //       this.props.toastErrorMsg("Select Type", "cmbType");
  //     } else if (
  //       !isValidItem(this.state.types, "type", this.state.formData.cmbType)
  //     ) {
  //       this.props.toastErrorMsg("Select Valid Type", "cmbType");
  //     } else if (this.state.formData.dtpFromDate.length <= 0) {
  //       this.props.toastErrorMsg("Enter Date", "dtpFromDate");
  //     } else if (
  //       validatedate_min_max(
  //         this.state.formData.dtpFromDate,
  //         "dtpFromDate",
  //         this.props.toastErrorMsg
  //       ) == false
  //     ) {
  //       return result;
  //     } else if (this.state.formData.dtpToDate.length <= 0) {
  //       this.props.toastErrorMsg("Enter Date", "dtpToDate");
  //     } else if (
  //       validatedate_min_max(
  //         this.state.formData.dtpToDate,
  //         "dtpToDate",
  //         this.props.toastErrorMsg
  //       ) == false
  //     ) {
  //       return result;
  //     } else if (
  //       this.state.formData.cmbCustomer.length > 0 &&
  //       !isValidItem(
  //         this.state.customers,
  //         "vac_customer",
  //         this.state.formData.cmbCustomer
  //       )
  //     ) {
  //       this.props.toastErrorMsg("Select Valid Customer", "cmbCustomer");
  //     } else {
  //       result = true;
  //     }
  //     return result;
  //   };

  setfrom_todate = (reset = false) => {
    setlocalstoragedate(
      "SalesReport",
      this.state.formData.dtpFromDate,
      this.state.formData.dtpToDate,
      reset
    );
    if (reset) {
      // window.location.reload();
      this.onFormLoad(reset);
      document.getElementById("dtpFromDate").focus();
    }
  };

  //   reqDataForReport = (bolChkDataExist) => {
  //     return {
  //       Op: "SalesReport",
  //       bint_acid: localStorage.getItem("acid"),
  //       bint_acyear: localStorage.getItem("ACY"),
  //       ReportType: this.getCmbType4BE(this.state.formData.cmbType),
  //       dat_fromdate: this.state.formData.dtpFromDate,
  //       dat_todate: this.state.formData.dtpToDate,
  //       vac_customer: this.state.formData.cmbCustomer,
  //       int_CustomerWisePage: this.state.formData.chekNewpage === true ? 1 : 0,
  //       bolChkDataExist: bolChkDataExist,
  //     };
  //   };

  openSalesReport = () => {
    if (this.validateFromToDate()) {
      this.props.notifyProcessing();
      let reqData = this.reqDataForReport(true);
      fetchSales(reqData)
        .then((res) => {
          if (res.data.msgType === "info") {
            let reqData = this.reqDataForReport(false);
            // Use URLSearchParams to convert the request data object into a query string
            let params = new URLSearchParams(reqData);

            let popupURL = apiURL + "salesdetail.php?" + params.toString();
            window.open(
              popupURL,
              "SalesReport",
              "width=" +
                window.screen.availWidth +
                ",height=" +
                window.screen.availHeight
            );
            this.props.updateProcessing("success", "PDF Open in popup.");
          } else {
            this.props.updateProcessing(res.data.msgType, res.data.message);
          }
        })
        .catch((error) => {
          console.log("Unknown error occurred in openSalesReport.", error);
          this.props.updateProcessing(
            "error",
            "Unknown error occurred in loading . " + error
          );
        });
      // Create a query string from the request data
    }
  };

  //   onFormLoad = (reset = false) => {
  //     const { fromdate, todate } = getlocalstoragedate("SalesReport");
  //     let dtpFromDate = fromdate,
  //       dtpToDate = todate;
  //     this.setState(
  //       {
  //         formData: {
  //           ...this.state.formData,
  //           dtpFromDate,
  //           dtpToDate,
  //         },
  //       },
  //       () => {
  //         if (reset == false) {
  //           this.loadCustomerList();
  //           document.getElementById("cmbType").focus();
  //         }
  //       }
  //     );
  //   };

  loadCustomerList = () => {
    // this.props.notifyProcessing();
    const reqData = {
      Op: "CustomerNameList",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchCustomerMaster(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        this.setState({ customers: res.data.CustomerList });
      })
      .catch((err) => {
        console.log("Unknown error occurred in getInfo.", err);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + err
        );
      });
  };
  //#endregion Function

  render() {
    return (
      <form>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Farmer Billl Print</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          {/* <Grid item>
            <CtCmbEditable
              id="cmbType"
              label="Type*"
              items={this.state.types}
              colID="type"
              value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              width={300}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpFromDate"
            /> */}
          {/* </Grid> */}
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                onClick={() => {
                  this.setfrom_todate(true);
                }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              label="તારીખ*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
              nextCtrlID="dtpToDate"
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="થી તારીખ*"
              width="150"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtTruckMasterPrefixNote"
              accountYear={localStorage.getItem("ACY")}

              // disabled={this.state.disabledProfileData.DOBDS}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtTruckMasterPrefixNote"
              label="બિલ નં,"
              handleOnChange={this.handleOnChange}
              value={this.state.formData.txtTruckMasterPrefixNote}
              width={100}
              maxLength={100}
              //   disabled={true}
              nextCtrlID="cmbCustomer"
            />
          </Grid>{" "}
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={3}
          marginTop={0}
        >
          <Grid item>
            <CtCmb
              id="cmbCustomer"
              label="કમિશન એજન્ટ કોડ"
              items={this.state.customers}
              colID="vac_customer"
              width={300}
              // value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbCustomer"
            />
          </Grid>
          <Grid item>
            <CtCmb
              id="cmbCustomer"
              label="કમિશન એજન્ટ નામ"
              items={this.state.customers}
              colID="vac_customer"
              width={300}
              // value={this.state.formData.cmbType}
              handleOnChange={this.handleOnChange}
              maxLength={50}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID=""
            />
          </Grid>
          <Grid item>
            {/* {this.state.formData.cmbType !== 'Date Wise Summary' && this.state.formData.cmbType !== 'Date Wise Detail' && ( */}
            {/* <FormControlLabel
              control={
                <Checkbox
                  id="chekNewpage"
                  name="chekNewpage"
                  value={this.state.formData.chekNewpage}
                  checked={this.state.formData.chekNewpage}
                  //  handleOnChange={this.handleOnCheckChange}/>
                  onChange={this.handleOnCheckChange}
                  disabled={
                    this.state.formData.cmbType === "Date Wise Summary" ||
                    this.state.formData.cmbType === "Date Wise Detail" ||
                    this.state.formData.cmbType === "Date Wise Detail With Item"
                  }
                />
              }
              label="Customer Wise New Page"
            /> */}
            {/* )} */}
          </Grid>
          <Grid item>
            <CtBtn
              label="પ્રિન્ટ"
              onClick={() => {
                this.trimFormData(() => {
                  this.openSalesReport();
                });
              }}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(SalesReport))));
